// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"72":"324e94001640b877","834":"55a10ad4b00f1edb","930":"db2ba7499c53ddbc"}[chunkId] + ".js";
};